import React from "react";
import LendersHero from "../components/Lenders/hero";
import LendersProblem from "../components/Lenders/problem";
import WhatYouControl from "../components/Lenders/control";
import IntakeQuality from "../components/Lenders/intake-quality";
import LendersOnboarding from "../components/Lenders/onboarding";
import FAQ from "../components/Global/faqs";
import PartnerForm from "../components/Lenders/partner-form";
import TrustedPartners from "../components/Home/trusted-partners";

const lendersFaqs = [
  {
    id: 1,
    question: "Do you compete with us?",
    answer:
      "Finverse funds some loans directly, but matching is neutral. Partner lenders and Finverse's own desk are ranked on fit, not preference.",
  },
  {
    id: 2,
    question: "Can we limit volume?",
    answer: "Yes. Set daily and monthly caps per product.",
  },
  {
    id: 3,
    question: "What is verified before we see a file?",
    answer:
      "Mobile match, name match and UPI/VPA confirmation, each timestamped.",
  },
  {
    id: 4,
    question: "How is commercial settlement handled?",
    answer:
      "Agreed per partner at onboarding and reconciled against disbursals.",
  },
];

export default function Lenders() {
  return (
    <main>
      <div className="pt-20">
        <LendersHero />
        <LendersProblem />
        <WhatYouControl />
        <IntakeQuality />
        <LendersOnboarding />
        <TrustedPartners />
        <FAQ faqs={lendersFaqs} label="LENDER FAQ" dark={true} />
        <PartnerForm />
      </div>
    </main>
  );
}
